import { render, staticRenderFns } from "./editIpcShopping.vue?vue&type=template&id=cc9ca588&scoped=true&"
import script from "./editIpcShopping.vue?vue&type=script&lang=js&"
export * from "./editIpcShopping.vue?vue&type=script&lang=js&"
import style0 from "./editIpcShopping.vue?vue&type=style&index=0&id=cc9ca588&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc9ca588",
  null
  
)

export default component.exports